<!-- <div  style="position: relative; width: 100%; height: 100%"> -->
    <section class="locked" *ngIf="loading" fxFlex fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner [strokeWidth]="5"></mat-spinner>
      </section>
      <!-- </div> -->
